 /**
 * Created by Mohammadreza on 12/29/2016.
 */
import { Injectable }     from '@angular/core';
import { Response } from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {API_URL_GET_SERVANT_BY_ID, API_URL_GET_SERVICE_BY_SERVANT_ID} from '../constants';
import { DOCUMENT } from '@angular/platform-browser';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {CacheUtilService} from "../../services/cache-util/CacheUtilService";
import { Inject } from '@angular/core';
import {BaseHttpService} from "../base-http-service";
import {ActivatedRoute} from '@angular/router';
import {CompanyVM} from "../../models/CompanyVM.model";
 import {ServantVM} from "../../models/ServiceItemDetailVM";


// export var currentServant:any = new CompanyVM('-');
@Injectable()
export class ServantService {
  private servant;
  public iframe:boolean = false;
  constructor(private http:BaseHttpService, private _cacheUtil:CacheUtilService, private activatedRoute:ActivatedRoute, @Inject(DOCUMENT) private document:any) {


  }
  getService(servantid):Observable<any> {

    if (servantid) {
      return this.http.get(API_URL_GET_SERVICE_BY_SERVANT_ID + '/' + servantid).map((res:Response) => {
        return res;
      })
      //...errors if any
        .catch((error:any) => Observable.throw(error || 'Server error'));
      //   }

    }

  }

  getServantById(servantid):Observable<ServantVM> {

    if (servantid) {
      return this.http.get(API_URL_GET_SERVANT_BY_ID + '/' + servantid).map((res:Response) => {
        return res;
      })
      //...errors if any
        .catch((error:any) => Observable.throw(error || 'Server error'));
      //   }

    }

  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/servant-service/servant-service.ts